<template>
  <el-dialog title="单据日志" :visible.sync="logVisible" width="1200px" :show-close="true">
    <div class="content plr-20 bg-f3f4f7 flex-column">
      <div class="addBtn cursor mt-10" @click="addLog">
        <img src="/static/images/customer/chubeikehu.png" alt="">
        <div>新增日志</div>
      </div>
      <div class="hr"></div>
      <div class="flex-1 h-0 flex-column">
        <div class="log-hd flex mb-10">
          <div class="flex-1">日志内容</div>
          <div class="w-85">服务人员</div>
          <div class="w-140">时间</div>
        </div>
        <div class="log-bd flex-1 mb-10">
          <el-scrollbar style="height: 100%;">
            <div class="flex logItem" v-for="(item, index) in dataList" :key="index">
              <div class="flex-1 pr-40 font-12-424142">
                <div class="mb-10">
                  {{item.content}}
                </div>
                <div class="flex">
                  <div v-for="(pic, i) in item.logPhotoList" :key="i" class="mr-10 mb-10">
                    <viewer :images="item.logPhotoList" style="z-index:9999">
                      <img style="width: 90px; height: 90px" :src="Utils.IMG_PREV + pic.path" fit="cover">
                    </viewer>
                  </div>
                </div>
              </div>
              <div class="w-85 font-12-b9b9b9">{{item.operatorName}}</div>
              <div class="w-140 font-12-b9b9b9">{{Utils.formatTime2(item.createTime)}}</div>
            </div>
          </el-scrollbar>
        </div>
      </div>
    </div>
    <add-log ref="addLog" :detailItem="detailItem"></add-log>
  </el-dialog>
</template>

<script>
import AddLog from './AddLog'
export default {
  name: 'Log',
  components: {AddLog},
  props: ['detailItem'],
  data () {
    return {
      logVisible: false,
      dataList: []
    }
  },
  created () {},
  mounted () {},
  methods: {
    getData () {
      this.axios.post(`orderLog/list`, {
        orderId: this.detailItem.id
      }).then(res => {
        if (res.data.success) {
          this.dataList = res.data.data
        }
      })
    },
    addLog () {
      this.$refs.addLog.addVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
  .content{
    height: 550px;
  }
  .addBtn{
    background: #fff;
    width: 85px;
    height: 24px;
    color: #30313a;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    border-radius: 4px;
  }
  .hr{
    width: 100%;
    height: 1px;
    background: #e2e2e2;
    margin: 10px 0;
  }
  .w-85{
    width: 85px;
  }
  .w-140{
    width: 140px;
  }
  .log-hd{
    text-align: left;
    font-size: 12px;
    color: #b6b6b6;
    padding: 0 10px;
  }
  .log-bd{
    text-align: left;
    overflow-y: auto;
  }
  .log-bd /deep/ .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .logItem{
    background: #fff;
    border-radius: 4px;
    margin-bottom: 10px;
    padding: 10px 10px 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/order/components/Log.vue